import React, { Fragment } from 'react';
import booking from '../../../../images/booking.jpg';
import booking1 from '../../../../images/booking1.jpg';
import booking2 from '../../../../images/makebooking2.png';

const MakeBooking = () => (
  <Fragment>
    <p>
      Making a booking is quick and easy. Click to watch the video{' '}
      <a
        className="faq__panel--link"
        target="_blank"
        href="https://www.youtube.com/watch?v=CtKZ-yt0wZs&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=2">
        here
      </a>{' '}
      and follow the 5 steps below:
    </p>
    <ol>
      <li>Open the Autzu app and select “Book”.</li>
      <li>Confirm whether you would like to book hourly or daily</li>
      <li>
        Choose where to pick-up your vehicle by tapping "Change" and swipe
        up or tap the pinpoint to select the hub closest to you.
      </li>
      <li>
        Enter your pick up and drop off time then select the day(s) of your
        booking
      </li>
      <li>Confirm your booking(s) to complete the booking process.</li>
    </ol>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={booking} style={{ width: '200px', height: '455px' }} />
      <img src={booking1} style={{ width: '200px', height: '455px' }} />
      <img src={booking2} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

export default MakeBooking;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/MakingABooking/MakeBooking.js